// Endpoints whose request and response bodies are dropped from the replay.
const SENSITIVE_URL = /\/(?:get-auth-user|get-cookie-user|stop-impersonation|reset|login|auth|password|token|billing|recordings?|messages?|sms|session-replay-meta|sso-link)\b/i

const SENSITIVE_HEADERS = ['authorization', 'cookie']

const CREDENTIAL_KEYS = 'api_token|token|hashed_token|shared_token|admin_token|access_token|refresh_token|auth_token|api_key|client_secret'

// Covers JSON string values and URL query params only; form-encoded and
// non-string bodies pass through unchanged.
const CREDENTIAL_FIELD = new RegExp(`("(?:${CREDENTIAL_KEYS})"\\s*:\\s*)"(?:[^"\\\\]|\\\\.)*"`, 'gi')
const CREDENTIAL_PARAM = new RegExp(`([?&](?:${CREDENTIAL_KEYS})=)[^&#]*`, 'gi')

export const redactTokens = body => typeof body === 'string'
  ? body.replace(CREDENTIAL_FIELD, '$1"[redacted]"')
  : body

export const redactUrl = url => typeof url === 'string'
  ? url.replace(CREDENTIAL_PARAM, '$1[redacted]')
  : url

export const requestSanitizer = request => {
  if (request.headers) {
    Object.keys(request.headers).forEach(name => {
      if (SENSITIVE_HEADERS.includes(name.toLowerCase())) {
        request.headers[name] = ''
      }
    })
  }

  request.body = SENSITIVE_URL.test(request.url) ? null : redactTokens(request.body)
  request.url = redactUrl(request.url)

  return request
}

export const responseSanitizer = response => {
  response.body = SENSITIVE_URL.test(response.url) ? null : redactTokens(response.body)
  response.url = redactUrl(response.url)

  return response
}
